import { APP_V2_APP_EVENTS, logEvent } from "@src/appV2/lib/analytics";

import { getStripe, STRIPE_ERROR_MESSAGE } from "./getStripe";
import { StripeIdentityVerificationFlowStatus } from "./types";

interface StartStripeIdentitySessionProps {
  verificationSessionId: string;
  clientSecret: string;
}

export async function startStripeIdentitySession(
  props: StartStripeIdentitySessionProps
): Promise<StripeIdentityVerificationFlowStatus> {
  const { clientSecret, verificationSessionId } = props;

  const stripe = await getStripe();
  if (!stripe) {
    throw new Error(STRIPE_ERROR_MESSAGE);
  }

  const { error } = await stripe.verifyIdentity(clientSecret);

  if (error) {
    logEvent(APP_V2_APP_EVENTS.STRIPE_IDENTITY_WEB_FLOW_ERROR, {
      error_code: error.code,
      error_message: error.message,
      error_type: error.type,
      verificationSessionId,
    });

    if (["session_cancelled", "consent_declined"].includes(error?.code ?? "")) {
      return StripeIdentityVerificationFlowStatus.CANCELED;
    }

    return StripeIdentityVerificationFlowStatus.FAILED;
  }

  return StripeIdentityVerificationFlowStatus.COMPLETED;
}
